import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const KeygeekUni = () => (
  <ArticleWrapper articleId="keygeek_uni">
    <div className="prose prose-invert mx-auto p-6">
      <h1>Keygeek Uni</h1>
      {/* Add your Keygeek Uni article content here */}
      <p>This is a placeholder article for the Keygeek Uni switch. More content coming soon.</p>
    </div>
  </ArticleWrapper>
);

export default KeygeekUni;
